import useAuth from '@State/Auth/useAuth';
import React from 'react';
import { useRoutes } from 'src/routes/useRoutes';
import { createGlobalStyle } from 'styled-components';
import { Theme } from './theme';
import { utilityClasses } from './utilityClasses';

const BaseGlobalStyle = createGlobalStyle<{ $isPublic: boolean; theme: Theme }>`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  html,
  body,
  #root {
    min-height: 100%;
  }

  /* always show scrollbar to avoid page jump */
  body {
    overflow-y: scroll;
  }

  html {
    font-size: 100%;
    -webkit-text-size-adjust: 100%;
    background-color: ${(props) =>
      props.$isPublic ? props.theme.color.primary.anthracite : props.theme.color.bg.main};
  }

  /* Services sidebar: sticky height from viewport minus header and action bar */
  :root {
    --services-sidebar-top: 0px;
    --services-sidebar-bottom: ${(props) => props.theme.size.service.bottomWrapperHeight};
  }

  body {
    margin: 0;
    background-color: ${(props) => props.theme.color.bg.main};
    color: ${(props) => props.theme.color.text.main};
    font-family: ${(props) => props.theme.font.family};
    line-height: ${(props) => props.theme.font.lineHeight.normal};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    letter-spacing: -0.2px;
    font-stretch: ${(props) => props.theme.font.stretch.regular};
  }

  a img {
    border: 0;
  }

  b,
  strong {
    font-weight: ${(props) => props.theme.font.weight.bold};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }

  pre {
    background: #d72669;
    background: springgreen;
    color: #fcfae1;
    color: #8e0191;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    display: table;
  }

  pre.todo::before {
    content: "TODO: ";
    color: #d72669;
  }

  ${utilityClasses}

  .hide {
    opacity: 0;
  }
`;

const GlobalStyle: React.FC<{ theme: Theme }> = ({ theme }) => {
  const { isPrivateRoute } = useRoutes();
  const { authenticated } = useAuth();
  const isPublic = !isPrivateRoute && !authenticated;

  return <BaseGlobalStyle $isPublic={isPublic} theme={theme} />;
};

export default GlobalStyle;
